module.exports = __webpack_public_path__ + "static/media/mistMountainScreenshot.b84affa5.jpg";